import React, { useState, useRef, useCallback, useEffect } from 'react';
import {
   Box,
   Flex,
   HStack,
   Button,
   Input,
   Text,
   IconButton,
   useColorModeValue,
   Modal,
   ModalOverlay,
   ModalContent,
   ModalHeader,
   ModalCloseButton,
   ModalBody,
   useDisclosure,
   useToast,
   Table,
   Thead,
   Tbody,
   Tr,
   Th,
   Td,
   TableContainer,
   Spinner,
} from '@chakra-ui/react';
import { Trash2, Plus, Copy, Image } from 'lucide-react';
import jsPDF from 'jspdf';
import { addPrintFormat, getPrintFormatById, updatePrintFormat } from '../../../../redux/actions/customizeprintings';
import { useDispatch, useSelector } from 'react-redux';
// import { getSetupFormatById } from '../../../../redux/actions/setupFormat';
import { Link, useParams } from 'react-router-dom';
import QueryEditorPage from './QueryEditorPage';
import { CLEAR_ONE_PRINT } from '../../../../redux/types';
import { IoMdArrowRoundBack } from 'react-icons/io';
import { getPageWidth } from 'constants';
import { getPageHeight } from 'constants';

const InvoiceFormatView = () => {
   let params = useParams();
   const url = params['*'];
   const id = params.id;
   const [queryText, setQueryText] = useState('');
   // const { isOpen: isQueryOpen, onOpen: onQueryOpen, onClose: onQueryClose } = useDisclosure();
   const { isOpen: isQueryOpen, onOpen: onQueryOpen, onClose: onQueryClose } = useDisclosure();

   let button = null;
   const singleEntityPrintQuery = useSelector((state) => state?.customizeprintings?.single?.query || {});
   const singleEntityPrintName = useSelector((state) => state?.customizeprintings?.single?.Name || 'Duplicated');
   const [elements, setElements] = useState({
      pageSize: 'a4',
      elements: [
         // Header with religious text
         {
            id: 'header-blessing',
            type: 'text',
            content: '!! ** Shree Ganeshay Namah ** !!',
            x: 50,
            y: 20,
            width: 495,
            height: 25,
            fontSize: 16,
            fontWeight: 'bold',
            color: '#000000',
            textAlign: 'center',
         },
         // Company name
         {
            id: 'company-name',
            type: 'text',
            content: 'SS WEB CREATION',
            x: 50,
            y: 50,
            width: 200,
            height: 30,
            fontSize: 20,
            fontWeight: 'bold',
            color: '#000000',
         },
         // Invoice type
         {
            id: 'invoice-type',
            type: 'text',
            content: 'TAX INVOICE',
            x: 400,
            y: 50,
            width: 150,
            height: 30,
            fontSize: 18,
            fontWeight: 'bold',
            color: '#000000',
            textAlign: 'center',
         },
         // Company address
         {
            id: 'company-address',
            type: 'text',
            content:
               'OFFICE NO. - 336, 3RD FLOOR, AVADH ARENA,\nOPP. MARVELLA CORIDOOR, NEAR SHYAMBABA TEMPLE, VIP ROAD, VESU\nEmail:info@sswebcreation.in (Ph):0261-35 45 369 , 99 25 25 23 22',
            x: 50,
            y: 80,
            width: 350,
            height: 60,
            fontSize: 10,
            fontWeight: 'normal',
            color: '#000000',
         },
         // GSTIN and other details
         {
            id: 'gstin-details',
            type: 'text',
            content: 'GSTIN: 24BJUPB4388N1ZI\nPAN: BJUPB4388N\nUAN: GJ-22D-0031950',
            x: 400,
            y: 80,
            width: 150,
            height: 60,
            fontSize: 10,
            fontWeight: 'normal',
            color: '#000000',
         },
         // Invoice details section
         {
            id: 'invoice-details',
            type: 'text',
            content: 'Invoice Date: 09-09-2024\nInvoice No.: 150\nDue Date: 09-09-2024\nPlace of Supply: 24-GUJARAT',
            x: 50,
            y: 160,
            width: 200,
            height: 80,
            fontSize: 11,
            fontWeight: 'normal',
            color: '#000000',
         },
         // Bill to section
         {
            id: 'bill-to-header',
            type: 'text',
            content: 'Billed to (Customer):',
            x: 50,
            y: 250,
            width: 150,
            height: 20,
            fontSize: 12,
            fontWeight: 'bold',
            color: '#000000',
         },
         {
            id: 'customer-info',
            type: 'text',
            content:
               'RUDRA FASHION\nPLOT NO. 1,2,3, GLOBAL IND Bhestan\nSURAT (Mo):9924289959, 9924289959, 898013\nGSTIN: 24BCGPS4404K1ZJ',
            x: 50,
            y: 270,
            width: 200,
            height: 80,
            fontSize: 11,
            fontWeight: 'normal',
            color: '#000000',
         },
         // Delivery address
         {
            id: 'delivery-header',
            type: 'text',
            content: 'Delivery Address:',
            x: 300,
            y: 250,
            width: 150,
            height: 20,
            fontSize: 12,
            fontWeight: 'bold',
            color: '#000000',
         },
         {
            id: 'delivery-info',
            type: 'text',
            content:
               'RUDRA FASHION\nPLOT NO. 1,2,3, GLOBAL IND Bhestan\nSURAT (Mo):9924289959, 9924289959, 898013\nGSTIN: 24BCGPS4404K1ZJ',
            x: 300,
            y: 270,
            width: 200,
            height: 80,
            fontSize: 11,
            fontWeight: 'normal',
            color: '#000000',
         },
         // Items table
         {
            id: 'items-table',
            type: 'table',
            content: 'Items Table',
            x: 50,
            y: 370,
            width: 500,
            height: 120,
            fontSize: 11,
            color: '#000000',
            tableFields: [
               {
                  id: 'sr-no',
                  label: 'Sr',
                  type: 'number',
                  width: 8,
                  alignment: 'center',
                  fontSize: 11,
                  fontWeight: 'normal',
                  color: '#000000',
                  backgroundColor: '#ffffff',
                  borderColor: '#000000',
                  borderWidth: 1,
                  padding: 4,
                  required: true,
                  placeholder: '1',
               },
               {
                  id: 'description',
                  label: 'Description of Service',
                  type: 'text',
                  width: 35,
                  alignment: 'left',
                  fontSize: 11,
                  fontWeight: 'normal',
                  color: '#000000',
                  backgroundColor: '#ffffff',
                  borderColor: '#000000',
                  borderWidth: 1,
                  padding: 4,
                  required: true,
                  placeholder: 'AMC SERVICE CHARGE - NODE',
               },
               {
                  id: 'hsn',
                  label: 'HSN',
                  type: 'text',
                  width: 12,
                  alignment: 'center',
                  fontSize: 11,
                  fontWeight: 'normal',
                  color: '#000000',
                  backgroundColor: '#ffffff',
                  borderColor: '#000000',
                  borderWidth: 1,
                  padding: 4,
                  required: true,
                  placeholder: '99831',
               },
               {
                  id: 'quantity',
                  label: 'Qty',
                  type: 'number',
                  width: 10,
                  alignment: 'center',
                  fontSize: 11,
                  fontWeight: 'normal',
                  color: '#000000',
                  backgroundColor: '#ffffff',
                  borderColor: '#000000',
                  borderWidth: 1,
                  padding: 4,
                  required: true,
                  placeholder: '1.00',
               },
               {
                  id: 'rate',
                  label: 'Rate',
                  type: 'currency',
                  width: 15,
                  alignment: 'right',
                  fontSize: 11,
                  fontWeight: 'normal',
                  color: '#000000',
                  backgroundColor: '#ffffff',
                  borderColor: '#000000',
                  borderWidth: 1,
                  padding: 4,
                  required: true,
                  placeholder: '3000.00',
               },
               {
                  id: 'amount',
                  label: 'Amount Rs.',
                  type: 'currency',
                  width: 20,
                  alignment: 'right',
                  fontSize: 11,
                  fontWeight: 'normal',
                  color: '#000000',
                  backgroundColor: '#ffffff',
                  borderColor: '#000000',
                  borderWidth: 1,
                  padding: 4,
                  required: true,
                  placeholder: '3000.00',
               },
            ],
            tableData: [
               {
                  id: 'row-1',
                  'sr-no': '1',
                  description: 'AMC SERVICE CHARGE - NODE',
                  hsn: '99831',
                  quantity: '1.00',
                  rate: '3000.00',
                  amount: '3000.00',
               },
               {
                  id: 'row-2',
                  'sr-no': '2',
                  description: 'Web Development Service',
                  hsn: '99832',
                  quantity: '2.00',
                  rate: '1500.00',
                  amount: '3000.00',
               },
            ],
            headerStyle: {
               backgroundColor: '#f8f9fa',
               fontWeight: 'bold',
               fontSize: 11,
               color: '#000000',
            },
            showBorders: true,
            alternateRowColors: false,
            evenRowColor: '#ffffff',
            oddRowColor: '#ffffff',
         },
         // Tax calculations
         {
            id: 'tax-section',
            type: 'text',
            content: 'Sub Total: 3000.00\nADD CGST 9.000%: 270.00\nADD SGST 9.000%: 270.00\nNet Amount Rs.: 3540.00',
            x: 350,
            y: 510,
            width: 200,
            height: 80,
            fontSize: 11,
            fontWeight: 'normal',
            color: '#000000',
            textAlign: 'right',
         },
         // Amount in words
         {
            id: 'amount-words',
            type: 'text',
            content: 'Rupees Three Thousand Five Hundred Forty Only.',
            x: 50,
            y: 510,
            width: 280,
            height: 20,
            fontSize: 11,
            fontWeight: 'bold',
            color: '#000000',
         },
         // Terms and conditions
         {
            id: 'terms-header',
            type: 'text',
            content: 'TERMS & CONDITIONS',
            x: 50,
            y: 550,
            width: 200,
            height: 20,
            fontSize: 12,
            fontWeight: 'bold',
            color: '#000000',
         },
         {
            id: 'terms-content',
            type: 'text',
            content:
               '1. SOFTWARE Support Will be Provided for 2 YEAR Only & AMC [Rs 1,00,000 /-] Will be Charged after 2 YEAR.\n2. Not to make any COPIES of this Software.\n3. Product Support will be Provided only during office hours (11.00 AM to 6.00 PM) on working days only.\n4. Any Support Required on [HOLIDAY OR AFTER 6:00 PM ON WORKING DAY] will be Chargeable.\n5. We are not liable in any manner whatsoever for any direct / indirect loss.',
            x: 50,
            y: 570,
            width: 500,
            height: 100,
            fontSize: 9,
            fontWeight: 'normal',
            color: '#000000',
         },
         // Bank details
         {
            id: 'bank-details',
            type: 'text',
            content:
               'Bank Details for RTGS / NEFT:\nBANK: CANARA BANK [SME BRANCH]\nACCOUNT NO: 3887201000219\nIFSC CODE: CNRB0003887',
            x: 50,
            y: 680,
            width: 200,
            height: 80,
            fontSize: 10,
            fontWeight: 'normal',
            color: '#000000',
         },
         // Signature section
         {
            id: 'signature',
            type: 'text',
            content: 'For SS WEB CREATION\n\n\nAuthorised Signatory',
            x: 400,
            y: 680,
            width: 150,
            height: 80,
            fontSize: 11,
            fontWeight: 'normal',
            color: '#000000',
            textAlign: 'center',
         },
         // Footer blessing
         {
            id: 'footer-blessing',
            type: 'text',
            content: '!! ** Shree Mahaviray Namah ** !!',
            x: 50,
            y: 780,
            width: 495,
            height: 25,
            fontSize: 14,
            fontWeight: 'bold',
            color: '#000000',
            textAlign: 'center',
         },
      ],
   });
   const [tablePagination, setTablePagination] = useState({});
   const MOVEMENT_STEP = 5;
   const dispatch = useDispatch();

   const [selectedElement, setSelectedElement] = useState(null);
   const [selectedTableField, setSelectedTableField] = useState(null);
   const [draggedElement, setDraggedElement] = useState(null);
   const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });
   const [showGrid, setShowGrid] = useState(true);
   const [zoom, setZoom] = useState(1);
   const [isGenerating, setIsGenerating] = useState(false);
   const [isLoading, setIsLoading] = useState(true);

   const canvasRef = useRef(null);
   const printRef = useRef(null);
   const { isOpen, onOpen, onClose } = useDisclosure();
   const toast = useToast();
   const hasLoadedFormat = useRef(false);
   if (url.includes(`/edit/${id}`)) {
      button = 'Edit';
   } else if (url.includes(`/copy/${id}`)) {
      button = 'Copy';
   }

   // const printFormatElements = useSelector((state) => JSON.parse(state.setupPrint?.single?.PrintFormat?.html));
   const printFormatElements = useSelector((state) => {
      try {
         return JSON.parse(state?.customizeprintings?.single?.html || elements);
      } catch (e) {
         console.error('Error parsing print format JSON:', e);
         return null;
      }
   });

   // const setupPrint = useSelector((state) => JSON.parse(state.setupPrint.customQuery) || {});

   const bgColor = useColorModeValue('gray.50', 'gray.900');
   const cardBg = useColorModeValue('white', 'gray.800');
   const borderColor = useColorModeValue('gray.200', 'gray.600');
   // useEffect(() => {
   //    setIsLoading(true);
   //    hasLoadedFormat.current = false;
   //    dispatch(getPrintFormatById(params.id));
   // }, [dispatch, params.id]);

   // useEffect(() => {
   //    if (printFormatElements && !hasLoadedFormat.current) {
   //       setElements(printFormatElements);
   //       setQueryText(singleEntityPrintQuery);
   //       hasLoadedFormat.current = true;
   //       setIsLoading(false);
   //    }
   // }, [printFormatElements, singleEntityPrintQuery]);
   useEffect(() => {
      const loadData = async () => {
         setIsLoading(true);
         try {
            await dispatch(getPrintFormatById(params.id));
            // Data will be handled in the next useEffect or you can handle it here
         } catch (error) {
            console.error('Failed to load data:', error);
            setIsLoading(false);
         }
      };

      if (params.id) {
         loadData();
      }
   }, [dispatch, params.id]);

   // Handle data updates
   useEffect(() => {
      if (printFormatElements && singleEntityPrintQuery) {
         setElements(printFormatElements);
         setQueryText(singleEntityPrintQuery);
         setIsLoading(false);
      }
   }, [printFormatElements, singleEntityPrintQuery]);

   // Function to move element in specified direction
   const moveElement = (elementId, direction, step = MOVEMENT_STEP) => {
      if (!elementId) return;

      setElements((prev) => {
         if (!prev || !prev.elements) return prev;

         return {
            ...prev,
            elements: prev.elements.map((element) => {
               if (element.id === elementId) {
                  let newX = element.x;
                  let newY = element.y;

                  switch (direction) {
                     case 'up':
                        newY = element.y - step;
                        break;
                     case 'down':
                        newY = element.y + step;
                        break;
                     case 'left':
                        newX = element.x - step;
                        break;
                     case 'right':
                        newX = element.x + step;
                        break;
                  }

                  // Apply grid snapping if enabled
                  if (showGrid) {
                     newX = Math.round(newX / 10) * 10;
                     newY = Math.round(newY / 10) * 10;
                  }

                  return { ...element, x: newX, y: newY };
               }
               return element;
            }),
         };
      });

      // Update selected element if it's the one being moved
      if (selectedElement && selectedElement.id === elementId) {
         setSelectedElement((prev) => {
            if (!prev || prev.id !== elementId) return prev;

            let newX = prev.x;
            let newY = prev.y;

            switch (direction) {
               case 'up':
                  newY = prev.y - step;
                  break;
               case 'down':
                  newY = prev.y + step;
                  break;
               case 'left':
                  newX = prev.x - step;
                  break;
               case 'right':
                  newX = prev.x + step;
                  break;
            }

            if (showGrid) {
               newX = Math.round(newX / 10) * 10;
               newY = Math.round(newY / 10) * 10;
            }

            return { ...prev, x: newX, y: newY };
         });
      }
   };

   const handleKeyDown = useCallback(
      (e) => {
         if (!selectedElement) return;

         // Check if user is typing in an input field
         if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') {
            return;
         }

         // Prevent default behavior for arrow keys
         if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(e.key)) {
            e.preventDefault();
         }

         // Determine step size (hold Shift for larger steps)
         const step = e.shiftKey ? MOVEMENT_STEP * 2 : MOVEMENT_STEP;

         switch (e.key) {
            case 'ArrowUp':
               moveElement(selectedElement.id, 'up', step);
               break;
            case 'ArrowDown':
               moveElement(selectedElement.id, 'down', step);
               break;
            case 'ArrowLeft':
               moveElement(selectedElement.id, 'left', step);
               break;
            case 'ArrowRight':
               moveElement(selectedElement.id, 'right', step);
               break;
            case 'Delete':
            case 'Backspace':
               if (selectedElement) {
                  deleteElement(selectedElement.id);
               }
               break;
         }
      },
      [selectedElement, showGrid],
   );
   // Add keyboard event listeners
   useEffect(() => {
      document.addEventListener('keydown', handleKeyDown);
      return () => {
         document.removeEventListener('keydown', handleKeyDown);
      };
   }, [handleKeyDown]);

   // Add these helper functions somewhere in your component
   // const getPageWidth = (size) => {
   //    switch (size) {
   //       case 'a3':
   //          return 842; // A3 width in pixels at 72dpi
   //       case 'a4':
   //          return 595; // A4 width
   //       case 'a5':
   //          return 420; // A5 width
   //       default:
   //          return 595;
   //    }
   // };

   // const getPageHeight = (size) => {
   //    switch (size) {
   //       case 'a3':
   //          return 1191; // A3 height
   //       case 'a4':
   //          return 842; // A4 height
   //       case 'a5':
   //          return 595; // A5 height
   //       default:
   //          return 842;
   //    }
   // };
   // Functions to manage table rows
   const addTableRow = (tableId) => {
      setElements((prev) =>
         prev.elements.map((element) => {
            if (element.id === tableId && element.type === 'table') {
               const newRowId = `row-${Date.now()}`;
               const newRow = {};

               // Initialize new row with empty values or placeholders
               element.tableFields.forEach((field) => {
                  newRow[field.id] = '';
               });
               newRow.id = newRowId;

               // Add serial number automatically
               if (element.tableFields.find((f) => f.id === 'sr-no')) {
                  newRow['sr-no'] = (element.tableData.length + 1).toString();
               }

               const updatedTableData = [...(element.tableData || []), newRow];

               // Calculate if we need to go to the next page
               const rowsPerPage = element.rowsPerPage || 10;
               const newTotalPages = Math.ceil(updatedTableData.length / rowsPerPage);

               // FIXED: Initialize pagination if it doesn't exist for this table
               if (!tablePagination[tableId]) {
                  setTablePagination((prev) => ({
                     ...prev,
                     [tableId]: {
                        currentPage: 1,
                        totalPages: newTotalPages,
                     },
                  }));
               }

               const currentPage = tablePagination[tableId]?.currentPage || 1;

               // If the new row would be on a new page, navigate to it
               if (updatedTableData.length > currentPage * rowsPerPage) {
                  setTablePagination((prev) => ({
                     ...prev,
                     [tableId]: {
                        ...(prev[tableId] || {}),
                        currentPage: newTotalPages,
                        totalPages: newTotalPages,
                     },
                  }));
               }

               return {
                  ...element,
                  tableData: updatedTableData,
                  rowsPerPage: rowsPerPage, // Save rowsPerPage to element if it doesn't exist
                  height: Math.max(element.height, 40 + Math.min(updatedTableData.length, rowsPerPage) * 25),
               };
            }
            return element;
         }),
      );
   };

   const deleteTableRow = (tableId, rowId) => {
      setElements((prev) =>
         prev.elements.map((element) => {
            if (element.id === tableId && element.type === 'table') {
               const updatedTableData = element.tableData.filter((row) => row.id !== rowId);

               // Reorder serial numbers
               const reorderedData = updatedTableData.map((row, index) => ({
                  ...row,
                  'sr-no': (index + 1).toString(),
               }));

               return {
                  ...element,
                  tableData: reorderedData,
                  height: Math.max(120, 40 + (reorderedData.length + 1) * 25), // Adjust height
               };
            }
            return element;
         }),
      );
   };

   const updateTableRowData = (tableId, rowId, fieldId, value) => {
      setElements((prev) =>
         prev.elements.map((element) => {
            if (element.id === tableId && element.type === 'table') {
               const updatedTableData = element.tableData.map((row) => {
                  if (row.id === rowId) {
                     const updatedRow = { ...row, [fieldId]: value };

                     // Auto-calculate amount if quantity and rate are updated
                     if (fieldId === 'quantity' || fieldId === 'rate') {
                        const quantity = parseFloat(updatedRow.quantity || 0);
                        const rate = parseFloat(updatedRow.rate || 0);
                        updatedRow.amount = (quantity * rate).toFixed(2);
                     }

                     return updatedRow;
                  }
                  return row;
               });

               return {
                  ...element,
                  tableData: updatedTableData,
               };
            }
            return element;
         }),
      );
   };

   const duplicateTableRow = (tableId, rowId) => {
      setElements((prev) =>
         prev.elements.map((element) => {
            if (element.id === tableId && element.type === 'table') {
               const rowToDuplicate = element.tableData.find((row) => row.id === rowId);
               if (rowToDuplicate) {
                  const newRowId = `row-${Date.now()}`;
                  const duplicatedRow = {
                     ...rowToDuplicate,
                     id: newRowId,
                     'sr-no': (element.tableData.length + 1).toString(),
                  };

                  const updatedTableData = [...element.tableData, duplicatedRow];

                  return {
                     ...element,
                     tableData: updatedTableData,
                     height: Math.max(element.height, 40 + (updatedTableData.length + 1) * 25),
                  };
               }
            }
            return element;
         }),
      );
   };

   const handleMouseDown = useCallback(
      (e, element) => {
         const rect = canvasRef.current.getBoundingClientRect();
         const offsetX = e.clientX - rect.left - element.x * zoom;
         const offsetY = e.clientY - rect.top - element.y * zoom;
         setDraggedElement(element);
         setDragOffset({ x: offsetX, y: offsetY });
         setSelectedElement(element);
         setSelectedTableField(null);
      },
      [zoom],
   );

   const handleMouseMove = useCallback(
      (e) => {
         if (!draggedElement) return;

         const rect = canvasRef.current.getBoundingClientRect();
         const newX = Math.max(0, (e.clientX - rect.left - dragOffset.x) / zoom);
         const newY = Math.max(0, (e.clientY - rect.top - dragOffset.y) / zoom);
         const snapX = showGrid ? Math.round(newX / 10) * 10 : newX;
         const snapY = showGrid ? Math.round(newY / 10) * 10 : newY;

         setElements((prev) => {
            // Safety check
            if (!prev || !prev.elements) {
               console.warn('Invalid elements state in handleMouseMove:', prev);
               return prev;
            }

            return {
               ...prev,
               elements: prev.elements.map((el) => (el.id === draggedElement.id ? { ...el, x: snapX, y: snapY } : el)),
            };
         });
      },
      [draggedElement, dragOffset, zoom, showGrid],
   );

   const handleMouseUp = useCallback(() => {
      setDraggedElement(null);
      setDragOffset({ x: 0, y: 0 });
   }, []);

   const handleImageUpload = (element, file) => {
      if (!file) return;
      const reader = new FileReader();
      reader.onload = (e) => {
         const imageData = e.target.result;
         updateElement(element.id, { src: imageData });
         // updateElement(element.id, 'src', imageData);
      };
      reader.onerror = (error) => {
         console.error('Error reading file:', error);
         alert('Error reading the image file');
      };
      reader.readAsDataURL(file);
   };

   const updateElement = (id, keyOrUpdates, updates) => {
      setElements((prev) => {
         if (!prev?.elements) return prev;

         return {
            ...prev,
            elements: prev.elements.map((element) => {
               if (element.id !== id) return element;

               let updatedElement =
                  typeof keyOrUpdates === 'object'
                     ? { ...element, ...keyOrUpdates }
                     : { ...element, [keyOrUpdates]: updates };

               if (updatedElement.type === 'line') {
                  const isVertical = updatedElement.isVertical;

                  if (typeof keyOrUpdates === 'object') {
                     if (keyOrUpdates.width !== undefined || keyOrUpdates.height !== undefined) {
                        if (isVertical) {
                           const newSize = keyOrUpdates.width ?? keyOrUpdates.height;
                           updatedElement.width = newSize;
                           updatedElement.height = newSize;
                        } else {
                           if (keyOrUpdates.width !== undefined) updatedElement.width = keyOrUpdates.width;
                           if (keyOrUpdates.height !== undefined) updatedElement.height = keyOrUpdates.height;
                        }
                     }
                  } else if (keyOrUpdates === 'width' || keyOrUpdates === 'height') {
                     if (isVertical) {
                        updatedElement.width = updates;
                        updatedElement.height = updates;
                     } else {
                        updatedElement[keyOrUpdates] = updates;
                     }
                  }
               }

               return updatedElement;
            }),
         };
      });

      setSelectedElement((prev) => {
         if (!prev || prev.id !== id) return prev;

         let updatedSelected =
            typeof keyOrUpdates === 'object' ? { ...prev, ...keyOrUpdates } : { ...prev, [keyOrUpdates]: updates };

         if (updatedSelected.type === 'line') {
            const isVertical = updatedSelected.isVertical;

            if (typeof keyOrUpdates === 'object') {
               if (keyOrUpdates.width !== undefined || keyOrUpdates.height !== undefined) {
                  if (isVertical) {
                     const newSize = keyOrUpdates.width ?? keyOrUpdates.height;
                     updatedSelected.width = newSize;
                     updatedSelected.height = newSize;
                  }
               }
            } else if (keyOrUpdates === 'width' || keyOrUpdates === 'height') {
               if (isVertical) {
                  updatedSelected.width = updates;
                  updatedSelected.height = updates;
               }
            }
         }

         return updatedSelected;
      });
   };

   const deleteElement = (id) => {
      setElements((prev) => ({
         ...prev,
         elements: prev.elements.filter((el) => el.id !== id),
      }));
      if (selectedElement && selectedElement.id === id) {
         setSelectedElement(null);
         setSelectedTableField(null);
      }
   };

   //working
   const generatePDF = async () => {
      setIsGenerating(true);
      try {
         const doc = new jsPDF('p', 'pt', 'a4');
         const pageHeight = doc.internal.pageSize.height;
         const pageWidth = doc.internal.pageSize.width;
         let currentPage = 1;
         let isFirstPage = true;

         // Helper function to add new page
         const addNewPage = () => {
            doc.addPage();
            currentPage++;
            isFirstPage = false;
         };

         // Process each element
         for (const element of elements.elements) {
            const x = element.x;
            const y = element.y;
            const fontSize = element.fontSize;

            // Set font properties
            doc.setFontSize(fontSize);

            // Handle font family
            if (element.fontFamily) {
               try {
                  doc.setFont(element.fontFamily, element.fontWeight || 'normal');
               } catch (fontError) {
                  console.warn('Font not available, using default:', element.fontFamily);
                  doc.setFont(undefined, element.fontWeight || 'normal');
               }
            } else {
               doc.setFont(undefined, element.fontWeight || 'normal');
            }

            // Set font style (italic, oblique)
            if (element.fontStyle && element.fontStyle !== 'normal') {
               try {
                  doc.setFont(undefined, element.fontWeight || 'normal', element.fontStyle);
               } catch (styleError) {
                  console.warn('Font style not available:', element.fontStyle);
               }
            }

            doc.setTextColor(element.color);

            // Handle different element types
            if (element.type === 'image' && element.src) {
               try {
                  // Enhanced image handling with better error checking
                  let imageData = element.src;

                  // Convert base64 or blob URLs to usable format
                  if (element.src.startsWith('data:')) {
                     imageData = element.src;
                  }

                  // Get image properties
                  const imgProps = doc.getImageProperties(imageData);
                  const pdfWidth = element.width;
                  const pdfHeight = element.height;

                  // Calculate dimensions based on objectFit
                  let finalWidth = pdfWidth;
                  let finalHeight = pdfHeight;
                  let offsetX = 0;
                  let offsetY = 0;

                  if (element.objectFit === 'contain') {
                     const imgRatio = imgProps.width / imgProps.height;
                     const containerRatio = pdfWidth / pdfHeight;

                     if (imgRatio > containerRatio) {
                        finalHeight = pdfWidth / imgRatio;
                        offsetY = (pdfHeight - finalHeight) / 2;
                     } else {
                        finalWidth = pdfHeight * imgRatio;
                        offsetX = (pdfWidth - finalWidth) / 2;
                     }
                  } else if (element.objectFit === 'cover') {
                     const imgRatio = imgProps.width / imgProps.height;
                     const containerRatio = pdfWidth / pdfHeight;

                     if (imgRatio > containerRatio) {
                        finalWidth = pdfHeight * imgRatio;
                        offsetX = (pdfWidth - finalWidth) / 2;
                     } else {
                        finalHeight = pdfWidth / imgRatio;
                        offsetY = (pdfHeight - finalHeight) / 2;
                     }
                  } else if (element.objectFit === 'fill') {
                     finalWidth = pdfWidth;
                     finalHeight = pdfHeight;
                     offsetX = 0;
                     offsetY = 0;
                  }

                  // Draw background if specified
                  if (element.backgroundColor && element.backgroundColor !== 'transparent') {
                     const [bgR, bgG, bgB] = hexToRgb(element.backgroundColor);
                     doc.setFillColor(bgR, bgG, bgB);
                     doc.rect(x, y, pdfWidth, pdfHeight, 'F');
                  }

                  // Draw border if specified
                  if (element.borderWidth > 0) {
                     const [borderR, borderG, borderB] = hexToRgb(element.borderColor || '#000000');
                     doc.setDrawColor(borderR, borderG, borderB);
                     doc.setLineWidth(element.borderWidth);

                     // Handle border styles
                     if (element.borderStyle === 'dashed') {
                        doc.setLineDash([3, 3]);
                     } else if (element.borderStyle === 'dotted') {
                        doc.setLineDash([1, 1]);
                     } else {
                        doc.setLineDash([]);
                     }

                     // Draw border with border radius if specified
                     if (element.borderRadius > 0) {
                        doc.roundedRect(x, y, pdfWidth, pdfHeight, element.borderRadius, element.borderRadius, 'S');
                     } else {
                        doc.rect(x, y, pdfWidth, pdfHeight, 'S');
                     }
                  }

                  // Determine image format
                  let imageFormat = 'JPEG';
                  if (imageData.includes('data:image/png')) {
                     imageFormat = 'PNG';
                  } else if (imageData.includes('data:image/gif')) {
                     imageFormat = 'GIF';
                  } else if (imageData.includes('data:image/webp')) {
                     imageFormat = 'WEBP';
                  }

                  // Add the image with enhanced parameters
                  doc.addImage(
                     imageData,
                     imageFormat,
                     x + offsetX,
                     y + offsetY,
                     finalWidth,
                     finalHeight,
                     undefined,
                     'FAST',
                     element.rotation || 0,
                  );

                  // Add image overlay effects if specified
                  if (element.overlay) {
                     const [overlayR, overlayG, overlayB] = hexToRgb(element.overlay.color || '#000000');
                     doc.setFillColor(overlayR, overlayG, overlayB);
                     doc.setGState(new doc.GState({ opacity: element.overlay.opacity || 0.5 }));
                     doc.rect(x, y, pdfWidth, pdfHeight, 'F');
                     doc.setGState(new doc.GState({ opacity: 1 }));
                  }
               } catch (error) {
                  console.error('Error adding image to PDF:', error);

                  // Enhanced error placeholder
                  const [placeholderR, placeholderG, placeholderB] = hexToRgb('#f5f5f5');
                  doc.setFillColor(placeholderR, placeholderG, placeholderB);
                  doc.rect(x, y, element.width, element.height, 'F');

                  doc.setDrawColor(200, 200, 200);
                  doc.setLineWidth(1);
                  doc.rect(x, y, element.width, element.height, 'S');

                  // Add broken image icon (simple X)
                  doc.setDrawColor(150, 150, 150);
                  doc.setLineWidth(2);
                  doc.line(x + 10, y + 10, x + element.width - 10, y + element.height - 10);
                  doc.line(x + element.width - 10, y + 10, x + 10, y + element.height - 10);

                  doc.setFontSize(10);
                  doc.setTextColor(128, 128, 128);
                  doc.text('Image not available', x + 10, y + element.height / 2);
               }
            } else if (element.type === 'table' && element.tableFields) {
               // Enhanced table handling with pagination
               const fields = element.tableFields;
               const allRows = element.tableData || [];
               const rowsPerPage = element.rowsPerPage || 10;
               const rowHeight = 20;
               const headerHeight = 25;

               // Calculate how many rows can fit on current page
               const remainingPageHeight = pageHeight - y - 50; // 50px margin from bottom
               const maxRowsOnCurrentPage = Math.floor((remainingPageHeight - headerHeight) / rowHeight);

               // Split data into pages
               const totalPages = Math.ceil(allRows.length / rowsPerPage);

               for (let pageIndex = 0; pageIndex < totalPages; pageIndex++) {
                  const startRowIndex = pageIndex * rowsPerPage;
                  const endRowIndex = Math.min(startRowIndex + rowsPerPage, allRows.length);
                  const pageRows = allRows.slice(startRowIndex, endRowIndex);

                  // Add new page if not the first page or first table
                  if (pageIndex > 0 || !isFirstPage) {
                     addNewPage();
                  }

                  // Set table position (same position for each page)
                  let currentY = y;

                  // Draw table header
                  let currentX = x;

                  // Set header font properties
                  doc.setFontSize(element.headerStyle.fontSize || 12);
                  doc.setFont(undefined, element.headerStyle.fontWeight || 'bold');

                  // Draw header background and cells
                  fields.forEach((field) => {
                     const fieldWidth = (element.width * field.width) / 100;

                     // Draw header background
                     const [headerBgR, headerBgG, headerBgB] = hexToRgb(
                        element.headerStyle.backgroundColor || '#f8f9fa',
                     );
                     doc.setFillColor(headerBgR, headerBgG, headerBgB);
                     doc.rect(currentX, currentY, fieldWidth, headerHeight, 'F');

                     // Draw header border
                     if (element.showBorders) {
                        doc.setDrawColor(0, 0, 0);
                        doc.setLineWidth(1);
                        doc.rect(currentX, currentY, fieldWidth, headerHeight, 'S');
                     }

                     // Add header text
                     const [headerTextR, headerTextG, headerTextB] = hexToRgb(element.headerStyle.color || '#000000');
                     doc.setTextColor(headerTextR, headerTextG, headerTextB);

                     const headerText = field.label || '';
                     const textX = currentX + (field.padding || 5);
                     const textY = currentY + headerHeight / 2 + (element.headerStyle.fontSize || 12) / 3;

                     doc.text(headerText, textX, textY);
                     currentX += fieldWidth;
                  });

                  currentY += headerHeight;

                  // Draw data rows for this page
                  pageRows.forEach((row, rowIndex) => {
                     currentX = x;
                     const actualRowIndex = startRowIndex + rowIndex;

                     fields.forEach((field) => {
                        const fieldWidth = (element.width * field.width) / 100;

                        // Set cell font properties
                        doc.setFontSize(field.fontSize || 10);
                        doc.setFont(undefined, field.fontWeight || 'normal');

                        // Draw cell background
                        let cellBgColor = '#ffffff';
                        if (element.alternateRowColors) {
                           cellBgColor =
                              actualRowIndex % 2 === 0
                                 ? element.evenRowColor || '#ffffff'
                                 : element.oddRowColor || '#f8f9fa';
                        } else {
                           cellBgColor = element.evenRowColor || '#ffffff';
                        }

                        const [cellBgR, cellBgG, cellBgB] = hexToRgb(cellBgColor);
                        doc.setFillColor(cellBgR, cellBgG, cellBgB);
                        doc.rect(currentX, currentY, fieldWidth, rowHeight, 'F');

                        // Draw cell border
                        if (element.showBorders) {
                           doc.setDrawColor(0, 0, 0);
                           doc.setLineWidth(1);
                           doc.rect(currentX, currentY, fieldWidth, rowHeight, 'S');
                        }

                        // Add cell text
                        const [cellTextR, cellTextG, cellTextB] = hexToRgb(field.color || '#000000');
                        doc.setTextColor(cellTextR, cellTextG, cellTextB);

                        const cellValue = row[field.id] || field.placeholder || '';
                        const textValue = cellValue !== null && cellValue !== undefined ? String(cellValue) : '';

                        // Handle text alignment
                        let textX = currentX + (field.padding || 5);
                        let textOptions = {};

                        if (field.alignment === 'center') {
                           textX = currentX + fieldWidth / 2;
                           textOptions.align = 'center';
                        } else if (field.alignment === 'right') {
                           textX = currentX + fieldWidth - (field.padding || 5);
                           textOptions.align = 'right';
                        }

                        const textY = currentY + rowHeight / 2 + (field.fontSize || 10) / 3;

                        // Handle multi-line text
                        const lines = textValue.split('\n');
                        if (lines.length > 1) {
                           const lineHeight = (field.fontSize || 10) * 1.2;
                           const startY = currentY + (field.padding || 5) + (field.fontSize || 10);

                           lines.forEach((line, lineIndex) => {
                              const lineY = startY + lineIndex * lineHeight;
                              if (lineY < currentY + rowHeight - 5) {
                                 // Ensure text fits in cell
                                 doc.text(line, textX, lineY, textOptions);
                              }
                           });
                        } else {
                           doc.text(textValue, textX, textY, textOptions);
                        }

                        currentX += fieldWidth;
                     });

                     currentY += rowHeight;
                  });

                  // Add page footer with pagination info
                  if (totalPages > 1) {
                     doc.setFontSize(8);
                     doc.setTextColor(128, 128, 128);
                     doc.text(
                        `Table Page ${pageIndex + 1} of ${totalPages} (Rows ${startRowIndex + 1}-${endRowIndex} of ${
                           allRows.length
                        })`,
                        x,
                        pageHeight - 30,
                     );
                  }

                  // Draw outer table border for better definition
                  if (element.showBorders) {
                     doc.setDrawColor(0, 0, 0);
                     doc.setLineWidth(1);
                     doc.rect(x, y, element.width, (pageRows.length + 1) * rowHeight + headerHeight - rowHeight, 'S');
                  }
               }

               // Set isFirstPage to false after first table
               isFirstPage = false;
            } else if (element.type === 'line') {
               // Handle line elements
               const [lineR, lineG, lineB] = hexToRgb(element.color || '#000000');
               doc.setDrawColor(lineR, lineG, lineB);
               doc.setLineWidth(element.thickness || element.height || 1);

               if (element.rotation) {
                  // For rotated lines, we need to calculate the end points
                  const radians = (element.rotation * Math.PI) / 180;

                  // Adjust starting point for vertical lines (90 degrees)
                  let startX = x;
                  let startY = y;

                  if (Math.abs(element.rotation) === 90) {
                     // For vertical lines, start from width/2 offset
                     startX = x + element.width / 2;
                  }

                  const endX = startX + element.width * Math.cos(radians);
                  const endY = startY + element.width * Math.sin(radians);
                  doc.line(startX, startY, endX, endY);
               } else {
                  // Horizontal line
                  doc.line(x, y + element.height / 2, x + element.width, y + element.height / 2);
               }
            } else {
               // Handle text elements with enhanced styling

               // Draw background if specified
               if (element.backgroundColor && element.backgroundColor !== 'transparent') {
                  const [textBgR, textBgG, textBgB] = hexToRgb(element.backgroundColor);
                  doc.setFillColor(textBgR, textBgG, textBgB);
                  doc.rect(x, y, element.width, element.height, 'F');
               }

               // Draw border if specified
               if (element.borderWidth > 0) {
                  const [textBorderR, textBorderG, textBorderB] = hexToRgb(element.borderColor || '#000000');
                  doc.setDrawColor(textBorderR, textBorderG, textBorderB);
                  doc.setLineWidth(element.borderWidth);

                  // Handle different border styles
                  if (element.borderStyle === 'dashed') {
                     doc.setLineDash([3, 3]);
                  } else if (element.borderStyle === 'dotted') {
                     doc.setLineDash([1, 1]);
                  } else {
                     doc.setLineDash([]);
                  }

                  // Draw border with border radius if specified
                  if (element.borderRadius > 0) {
                     doc.roundedRect(
                        x,
                        y,
                        element.width,
                        element.height,
                        element.borderRadius,
                        element.borderRadius,
                        'S',
                     );
                  } else {
                     doc.rect(x, y, element.width, element.height, 'S');
                  }
               }

               // Set text properties with enhanced font handling
               doc.setFontSize(fontSize);

               // Set font family and style
               if (element.fontFamily) {
                  try {
                     doc.setFont(element.fontFamily, element.fontWeight || 'normal');
                  } catch (fontError) {
                     console.warn('Font not available, using default:', element.fontFamily);
                     doc.setFont(undefined, element.fontWeight || 'normal');
                  }
               } else {
                  doc.setFont(undefined, element.fontWeight || 'normal');
               }

               // Apply font style (italic, oblique)
               if (element.fontStyle && element.fontStyle !== 'normal') {
                  try {
                     doc.setFont(undefined, element.fontWeight || 'normal', element.fontStyle);
                  } catch (styleError) {
                     console.warn('Font style not available:', element.fontStyle);
                  }
               }

               const [textR, textG, textB] = hexToRgb(element.color || '#000000');
               doc.setTextColor(textR, textG, textB);

               const lines = element.content.split('\n');
               const lineHeight = element.lineHeight || 1.2;
               const actualLineHeight = fontSize * lineHeight;

               lines.forEach((line, index) => {
                  let textX = x + (element.padding || 0);
                  let textOptions = {};

                  // Apply text transform
                  let displayText = line;
                  if (element.textTransform === 'uppercase') {
                     displayText = line.toUpperCase();
                  } else if (element.textTransform === 'lowercase') {
                     displayText = line.toLowerCase();
                  } else if (element.textTransform === 'capitalize') {
                     displayText = line.charAt(0).toUpperCase() + line.slice(1);
                  }

                  // Handle text alignment
                  if (element.textAlign === 'center') {
                     textX = x + element.width / 2;
                     textOptions.align = 'center';
                  } else if (element.textAlign === 'right') {
                     textX = x + element.width - (element.padding || 0);
                     textOptions.align = 'right';
                  }

                  // Apply letter spacing (approximate)
                  if (element.letterSpacing && element.letterSpacing !== 0) {
                     textOptions.charSpace = element.letterSpacing;
                  }

                  // Handle text decoration (underline, strikethrough)
                  if (element.textDecoration === 'underline') {
                     textOptions.underline = true;
                  } else if (element.textDecoration === 'line-through') {
                     textOptions.strikethrough = true;
                  }

                  const textY = y + (element.padding || 0) + index * actualLineHeight + fontSize;
                  doc.text(displayText, textX, textY, textOptions);
               });
            }
         }

         doc.save('invoice-format.pdf');
         toast({
            title: 'PDF Generated',
            description: 'Invoice format has been exported successfully!',
            status: 'success',
            duration: 3000,
            isClosable: true,
         });
      } catch (error) {
         console.error('PDF generation failed:', error);
         toast({
            title: 'Export Failed',
            description: 'Failed to generate PDF. Please try again.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
      } finally {
         setIsGenerating(false);
      }
   };

   //working Enhanced helper function to convert hex color to RGB
   const hexToRgb = (hex) => {
      if (!hex) return [0, 0, 0];

      // Handle named colors
      const namedColors = {
         transparent: [255, 255, 255],
         black: [0, 0, 0],
         white: [255, 255, 255],
         red: [255, 0, 0],
         green: [0, 255, 0],
         blue: [0, 0, 255],
         gray: [128, 128, 128],
         lightgray: [211, 211, 211],
         darkgray: [169, 169, 169],
      };

      if (namedColors[hex.toLowerCase()]) {
         return namedColors[hex.toLowerCase()];
      }

      // Remove # if present
      hex = hex.replace('#', '');

      // Handle 3-digit hex
      if (hex.length === 3) {
         hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
      }

      // Handle invalid hex
      if (hex.length !== 6) {
         return [0, 0, 0];
      }

      const r = parseInt(hex.substr(0, 2), 16);
      const g = parseInt(hex.substr(2, 2), 16);
      const b = parseInt(hex.substr(4, 2), 16);

      // Return valid RGB values
      return [isNaN(r) ? 0 : r, isNaN(g) ? 0 : g, isNaN(b) ? 0 : b];
   };

   const handleQuerySave = (query) => {
      setQueryText(query);

      const formdata = {
         id: parseInt(params.id),
         query,
      };

      dispatch(updatePrintFormat(formdata));

      setTimeout(() => {
         onQueryClose();
      }, 1000);
   };

   const handleSave = async () => {
      setIsGenerating(true);
      try {
         if (url.includes(`/edit/${id}`)) {
            button = 'Edit';
            const formdata = {
               id: parseInt(params.id),
               html: JSON.stringify({
                  pageSize: elements.pageSize,
                  elements: elements.elements,
               }),
               // html: JSON.stringify(elements),
            };
            dispatch(updatePrintFormat(formdata));
            dispatch({ type: CLEAR_ONE_PRINT, payload: null, single: null });
         } else if (url.includes(`/copy/${id}`)) {
            const formdata = {
               id: parseInt(params.id),
               html: JSON.stringify({
                  pageSize: elements.pageSize,
                  elements: elements.elements,
               }),
               query: singleEntityPrintQuery,
               Name: singleEntityPrintName,
               // html: JSON.stringify(elements),
            };

            dispatch(addPrintFormat(formdata));
         }
         // const formdata = {
         //    id: parseInt(params.id),
         //    html: JSON.stringify({
         //       pageSize: elements.pageSize,
         //       elements: elements.elements,
         //    }),
         //    // html: JSON.stringify(elements),
         // };

         // dispatch(updatePrintFormat(formdata));

         toast({
            title: 'Save Invoice Format',
            description: 'Invoice format has been exported successfully!',
            status: 'success',
            duration: 3000,
            isClosable: true,
         });
      } catch (error) {
         console.error('PDF generation failed:', error);
         toast({
            title: 'Export Failed',
            description: 'Failed to generate PDF. Please try again.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
      } finally {
         setIsGenerating(false);
      }
   };

   const renderTableElement = (element, isPreview = false) => {
      const fields = element.tableFields || [];
      const rows = element.tableData || [];
      const totalWidth = element.width * (isPreview ? 1 : zoom);

      return (
         <TableContainer width={totalWidth} height={element.height * (isPreview ? 1 : zoom)}>
            <Table variant="simple" size="sm">
               <Thead>
                  <Tr>
                     {fields.map((field, fieldIndex) => (
                        <Th
                           key={field.id}
                           width={`${field.width}%`}
                           textAlign={field.alignment}
                           fontSize={`${element.headerStyle.fontSize * (isPreview ? 1 : zoom)}px`}
                           fontWeight={element.headerStyle.fontWeight}
                           color={element.headerStyle.color}
                           backgroundColor={element.headerStyle.backgroundColor}
                           border={element.showBorders ? `${field.borderWidth}px solid ${field.borderColor}` : 'none'}
                           borderRight={
                              element.showColumnLines
                                 ? `${field.borderWidth || 1}px solid ${field.borderColor || '#E2E8F0'}`
                                 : element.showBorders
                                 ? `${field.borderWidth}px solid ${field.borderColor}`
                                 : 'none'
                           }
                           borderLeft={
                              element.showColumnLines
                                 ? `${field.borderWidth || 1}px solid ${field.borderColor || '#E2E8F0'}`
                                 : element.showBorders
                                 ? `${field.borderWidth}px solid ${field.borderColor}`
                                 : 'none'
                           }
                           padding={`${field.padding}px`}>
                           {field.label}
                        </Th>
                     ))}
                     {!isPreview && element.showDeleteButton && (
                        <Th
                           width="60px"
                           textAlign="center"
                           borderLeft={
                              element.showColumnLines
                                 ? `1px solid ${element.tableFields?.[0]?.borderColor || '#E2E8F0'}`
                                 : 'none'
                           }>
                           Actions
                        </Th>
                     )}
                  </Tr>
               </Thead>
               <Tbody>
                  {rows.map((row, rowIndex) => (
                     <Tr
                        key={row.id}
                        backgroundColor={
                           element.alternateRowColors
                              ? rowIndex % 2 === 0
                                 ? element.evenRowColor
                                 : element.oddRowColor
                              : element.evenRowColor
                        }>
                        {fields.map((field, fieldIndex) => (
                           <Td
                              key={field.id}
                              textAlign={field.alignment}
                              fontSize={`${field.fontSize * (isPreview ? 1 : zoom)}px`}
                              fontWeight={field.fontWeight}
                              color={field.color}
                              backgroundColor={field.backgroundColor}
                              border={
                                 element.showBorders ? `${field.borderWidth}px solid ${field.borderColor}` : 'none'
                              }
                              borderRight={
                                 element.showColumnLines
                                    ? `${field.borderWidth || 1}px solid ${field.borderColor || '#E2E8F0'}`
                                    : element.showBorders
                                    ? `${field.borderWidth}px solid ${field.borderColor}`
                                    : 'none'
                              }
                              borderLeft={
                                 element.showColumnLines
                                    ? `${field.borderWidth || 1}px solid ${field.borderColor || '#E2E8F0'}`
                                    : element.showBorders
                                    ? `${field.borderWidth}px solid ${field.borderColor}`
                                    : 'none'
                              }
                              padding={`${field.padding}px`}>
                              {isPreview ? (
                                 <Text>{row[field.id] || field.placeholder}</Text>
                              ) : (
                                 <Input
                                    value={row[field.id] || ''}
                                    onChange={(e) => updateTableRowData(element.id, row.id, field.id, e.target.value)}
                                    placeholder={field.placeholder}
                                    size="sm"
                                    variant="unstyled"
                                    textAlign={field.alignment}
                                    fontSize={`${field.fontSize * zoom}px`}
                                    fontWeight={field.fontWeight}
                                    color={field.color}
                                    type={field.type === 'number' || field.type === 'currency' ? 'number' : 'text'}
                                    step={field.type === 'currency' ? '0.01' : '1'}
                                 />
                              )}
                           </Td>
                        ))}
                        {!isPreview && element.showDeleteButton && (
                           <Td textAlign="center" width="60px">
                              <HStack spacing={1}>
                                 <IconButton
                                    size="xs"
                                    icon={<Copy size={12} />}
                                    onClick={() => duplicateTableRow(element.id, row.id)}
                                    colorScheme="blue"
                                    variant="ghost"
                                    title="Duplicate Row"
                                 />
                                 <IconButton
                                    size="xs"
                                    icon={<Trash2 size={12} />}
                                    onClick={() => deleteTableRow(element.id, row.id)}
                                    colorScheme="red"
                                    variant="ghost"
                                    title="Delete Row"
                                    isDisabled={rows.length <= 1}
                                 />
                              </HStack>
                           </Td>
                        )}
                     </Tr>
                  ))}
               </Tbody>
            </Table>

            {!isPreview && element.showAddButton && rows.length < element.maxRows && (
               <Button
                  size="sm"
                  leftIcon={<Plus size={14} />}
                  onClick={() => addTableRow(element.id)}
                  colorScheme="blue"
                  variant="outline"
                  width="100%"
                  mt={2}>
                  Add Row
               </Button>
            )}
         </TableContainer>
      );
   };

   //working
   const renderElement = (element, isPreview = false) => {
      const isSelected = !isPreview && selectedElement && selectedElement.id === element.id;

      // Special handling for image elements
      if (element.type === 'image') {
         const imageStyle = {
            position: 'absolute',
            left: element.x * (isPreview ? 1 : zoom),
            top: element.y * (isPreview ? 1 : zoom),
            width: element.width * (isPreview ? 1 : zoom),
            height: element.height * (isPreview ? 1 : zoom),
            cursor: isPreview ? 'default' : 'move',
            border: isSelected ? '2px solid #3B82F6' : '1px solid #E5E7EB',
            backgroundColor: element.backgroundColor || '#F9FAFB',
            borderRadius: element.borderRadius || 0,
            opacity: element.opacity || 1,
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
         };

         return (
            <Box
               key={element.id}
               style={imageStyle}
               onMouseDown={isPreview ? undefined : (e) => handleMouseDown(e, element)}
               userSelect="none"
               position="relative">
               {element.src ? (
                  <img
                     src={element.src}
                     alt={element.alt || 'Image'}
                     style={{
                        width: '100%',
                        height: '100%',
                        objectFit: element.objectFit || 'contain',
                        borderRadius: element.borderRadius || 0,
                     }}
                  />
               ) : (
                  <Box
                     w="100%"
                     h="100%"
                     display="flex"
                     flexDirection="column"
                     alignItems="center"
                     justifyContent="center"
                     color="#6B7280"
                     fontSize={isPreview ? '12px' : `${12 * zoom}px`}
                     textAlign="center"
                     p={2}>
                     <Image size={24} style={{ marginBottom: 8 }} />
                     <Text fontSize="xs">{isPreview ? 'No Image' : element.placeholder || 'Click to upload'}</Text>
                  </Box>
               )}

               {/* Upload overlay for edit mode */}
               {!isPreview && !element.src && (
                  <Input
                     type="file"
                     accept="image/*"
                     position="absolute"
                     top="0"
                     left="0"
                     width="100%"
                     height="100%"
                     opacity="0"
                     cursor="pointer"
                     onChange={(e) => {
                        const file = e.target.files[0];
                        if (file) {
                           handleImageUpload(element, file);
                        }
                     }}
                  />
               )}

               {isSelected && (
                  <IconButton
                     position="absolute"
                     top="-4px"
                     right="-4px"
                     size="xs"
                     colorScheme="red"
                     borderRadius="full"
                     icon={<Trash2 size={12} />}
                     onClick={(e) => {
                        e.stopPropagation();
                        deleteElement(element.id);
                     }}
                  />
               )}
            </Box>
         );
      }

      // Special handling for line elements
      if (element.type === 'line') {
         const lineStyle = {
            position: 'absolute',
            left: element.x * (isPreview ? 1 : zoom),
            top: element.y * (isPreview ? 1 : zoom),
            width: element.width * (isPreview ? 1 : zoom),
            height: element.height * (isPreview ? 1 : zoom),
            cursor: isPreview ? 'default' : 'move',
            border: isSelected ? '2px solid #3B82F6' : '1px solid transparent',
            backgroundColor: isSelected ? 'rgba(59, 130, 246, 0.1)' : element.backgroundColor || 'transparent',
            minHeight: isPreview ? element.height : Math.max(element.height, 10),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
         };

         return (
            <Box
               key={element.id}
               style={lineStyle}
               onMouseDown={isPreview ? undefined : (e) => handleMouseDown(e, element)}
               userSelect="none"
               position="relative">
               <Box
                  w="100%"
                  h={`${element.thickness || element.height}px`}
                  bg={element.color || '#000000'}
                  style={{
                     transform: element.rotation ? `rotate(${element.rotation}deg)` : 'none',
                     transformOrigin: 'center center',
                  }}
               />
               {isSelected && (
                  <IconButton
                     position="absolute"
                     top="-4px"
                     right="-4px"
                     size="xs"
                     colorScheme="red"
                     borderRadius="full"
                     icon={<Trash2 size={12} />}
                     onClick={(e) => {
                        e.stopPropagation();
                        deleteElement(element.id);
                     }}
                  />
               )}
            </Box>
         );
      }

      // FIXED: Determine proper whiteSpace and wordWrap behavior
      const getTextWrapStyle = () => {
         // If wordWrap is set to 'break-word', allow wrapping
         if (element.wordWrap === 'break-word') {
            return {
               whiteSpace: 'pre-wrap', // Allow wrapping and preserve line breaks
               wordWrap: 'break-word',
               wordBreak: 'break-word', // Additional CSS property for better wrapping
               overflow: 'visible',
            };
         }

         // For specific element types that should wrap by default
         if (element.type === 'client' || element.type === 'notes') {
            return {
               whiteSpace: 'pre-wrap',
               wordWrap: 'normal',
               overflow: 'visible',
            };
         }

         // For custom whiteSpace settings
         if (element.whiteSpace === 'pre-wrap') {
            return {
               whiteSpace: 'pre-wrap',
               wordWrap: element.wordWrap || 'normal',
               overflow: 'visible',
            };
         }

         // Default behavior - no wrapping
         return {
            whiteSpace: element.whiteSpace || 'nowrap',
            wordWrap: element.wordWrap || 'normal',
            overflow: 'hidden',
         };
      };
      const getVerticalAlignStyle = () => {
         const verticalAlign = element.verticalAlign || 'top';

         switch (verticalAlign) {
            case 'middle':
               return {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent:
                     element.textAlign === 'center'
                        ? 'center'
                        : element.textAlign === 'right'
                        ? 'flex-end'
                        : 'flex-start',
               };
            case 'bottom':
               return {
                  display: 'flex',
                  alignItems: 'flex-end',
                  justifyContent:
                     element.textAlign === 'center'
                        ? 'center'
                        : element.textAlign === 'right'
                        ? 'flex-end'
                        : 'flex-start',
               };
            case 'top':
            default:
               return {
                  display: 'flex',
                  alignItems: 'flex-start',
                  justifyContent:
                     element.textAlign === 'center'
                        ? 'center'
                        : element.textAlign === 'right'
                        ? 'flex-end'
                        : 'flex-start',
               };
         }
      };
      const textWrapStyle = getTextWrapStyle();
      const verticalAlignStyle = getVerticalAlignStyle();

      // Regular element styling for other elements
      const elementStyle = {
         position: 'absolute',
         left: element.x * (isPreview ? 1 : zoom),
         top: element.y * (isPreview ? 1 : zoom),
         width: element.width * (isPreview ? 1 : zoom),
         height: element.height * (isPreview ? 1 : zoom),
         fontSize: element.fontSize * (isPreview ? 1 : zoom),
         fontWeight: element.fontWeight || 'normal',
         fontStyle: element.fontStyle || 'normal',
         fontFamily: element.fontFamily || 'Arial',
         color: element.color || '#000000',
         textAlign: element.textAlign || 'left',
         textDecoration: element.textDecoration || 'none',
         border: isSelected ? '2px solid #3B82F6' : '1px solid transparent',
         cursor: isPreview ? 'default' : 'move',
         // FIXED: Apply proper text wrapping styles
         ...textWrapStyle,
         ...verticalAlignStyle,
         backgroundColor: element.backgroundColor || 'transparent',
         borderColor: element.borderColor || 'transparent',
         borderWidth: element.borderWidth || 0,
         borderStyle: element.borderStyle || 'solid',
         borderRadius: element.borderRadius || 0,
         padding: element.padding || '4px',
         opacity: element.opacity || 1,
         textTransform: element.textTransform || 'none',
         lineHeight: element.lineHeight || 1.2,
         letterSpacing: `${element.letterSpacing || 0}px`,
         boxShadow: isSelected ? 'inset 0 0 0 2px rgba(59, 130, 246, 0.1)' : 'none',
      };

      return (
         <Box
            key={element.id}
            style={elementStyle}
            onMouseDown={isPreview ? undefined : (e) => handleMouseDown(e, element)}
            userSelect="none"
            position="relative">
            {element.type === 'table' ? renderTableElement(element, isPreview) : <Box>{element.content}</Box>}
            {isSelected && (
               <IconButton
                  position="absolute"
                  top="-4px"
                  right="-4px"
                  size="xs"
                  colorScheme="red"
                  borderRadius="full"
                  icon={<Trash2 size={12} />}
                  onClick={(e) => {
                     e.stopPropagation();
                     deleteElement(element.id);
                  }}
               />
            )}
         </Box>
      );
   };

   const PreviewModal = () => (
      <Modal isOpen={isOpen} onClose={onClose} size="12xl">
         <ModalOverlay />
         <ModalContent maxW="100vw" maxH="100vh">
            <ModalHeader>
               <Flex justify={'space-between'} align={'center'}>
                  <Text>Invoice Preview</Text>
                  <Box>
                     <Button colorScheme="green" mr={3} onClick={handleSave} isLoading={isGenerating}>
                        {button}
                     </Button>
                     <Button colorScheme="blue" mr={10} onClick={generatePDF} isLoading={isGenerating}>
                        Export PDF
                     </Button>
                     {/* <Button onClick={onClose}>Close</Button> */}
                  </Box>
               </Flex>{' '}
            </ModalHeader>

            <ModalCloseButton />
            <ModalBody>
               <Box
                  ref={printRef}
                  width={`${getPageWidth(elements.pageSize)}px`}
                  height={`${getPageHeight(elements.pageSize)}px`}
                  bg="white"
                  border="1px solid"
                  borderColor="gray.300"
                  mx="auto"
                  position="relative"
                  overflow="hidden">
                  {elements.elements.map((element) => renderElement(element, true))}
               </Box>
            </ModalBody>
         </ModalContent>
      </Modal>
   );

   if (isLoading) {
      return (
         <Flex justify="center" align="center" minH="100vh" bg={bgColor}>
            <Spinner size="xl" thickness="4px" speed="0.65s" color="blue.500" />
         </Flex>
      );
   }

   return (
      <Flex h="100vh" bg={bgColor} overflowY="auto">
         {/* Canvas */}
         <Box flex={1} position="relative" overflow="hidden" mt={6}>
            <Box
               ref={canvasRef}
               w="full"
               h="full"
               position="relative"
               bg="white"
               style={{
                  backgroundImage: showGrid
                     ? `linear-gradient(to right, #f0f0f0 1px, transparent 1px),
                 linear-gradient(to bottom, #f0f0f0 1px, transparent 1px)`
                     : 'none',
                  backgroundSize: showGrid ? `${10 * zoom}px ${10 * zoom}px` : 'auto',
               }}
               onMouseMove={handleMouseMove}
               onMouseUp={handleMouseUp}
               onMouseLeave={handleMouseUp}>
               <Link to="/admin/setting/print-settings">
                  <Button mb="12px">
                     <IoMdArrowRoundBack size={18} />
                  </Button>
               </Link>
               {/* A4 Paper simulation */}
               <Box
                  position="absolute"
                  left="70px"
                  top="20px"
                  width={`${getPageWidth(elements)}px`}
                  height={`${getPageHeight(elements)}px`}
                  // width={`${getPageWidth(elements.pageSize) * zoom}px`}
                  // height={`${getPageHeight(elements.pageSize) * zoom}px`}
                  bg="white"
                  shadow="lg"
                  border="1px solid"
                  borderColor="gray.300">
                  {elements && elements.elements && elements.elements.map((element) => renderElement(element))}
               </Box>
            </Box>
         </Box>

         {/* Preview Modal */}
         <PreviewModal />
         <QueryEditorPage
            initialQuery={queryText}
            setQueryText={setQueryText}
            onSave={handleQuerySave}
            isOpen={isQueryOpen}
            onClose={onQueryClose}
         />
      </Flex>
   );
};

export default InvoiceFormatView;
